<template>
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div>
          <h4 class="mb-25"><i class="fa fa-envelope-open-o"></i> التعاميم</h4>
          <span class="text-muted">من فتح التعميم، ومن وقّع على استلامه، ومن رد.</span>
        </div>
        <router-link to="/_teachers/mails/send" class="btn btn-primary"><i class="fa fa-plus"></i> تعميم جديد</router-link>
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center g">
          <img :src="require('@/assets/images/loading.svg')" style="width: 50px" alt="">
        </div>
        <p v-else-if="!mails.length" class="text-muted text-center g mb-0">لم يتم إرسال أي تعميم بعد.</p>
        <div class="table-responsive" v-else>
          <table class="table table-hover table-bordered table-sm mails">
            <thead>
              <tr>
                <th>التعميم</th>
                <th>التاريخ</th>
                <th>المرسل لهم</th>
                <th>قرأ</th>
                <th>وقّع</th>
                <th>رد</th>
                <th>خيارات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="m in mails" :key="m._id">
                <td>
                  <strong>{{ m.title }}</strong>
                  <a v-if="m.file" :href="m.file" target="_blank" class="d-block small"><i class="fa fa-paperclip"></i> مرفق</a>
                </td>
                <td class="num">{{ m.date }}</td>
                <td class="num">{{ m.sent }}</td>
                <td><div class="stat"><span class="num">{{ m.seen }}</span><div class="bar"><i :style="{ width: pct(m.seen, m.sent) }"></i></div></div></td>
                <td><div class="stat ok"><span class="num">{{ m.signed }}</span><div class="bar"><i :style="{ width: pct(m.signed, m.sent) }"></i></div></div></td>
                <td><div class="stat info"><span class="num">{{ m.replied }}</span><div class="bar"><i :style="{ width: pct(m.replied, m.sent) }"></i></div></div></td>
                <td class="nowrap">
                  <button class="btn btn-sm btn-primary" @click="open(m)"><i class="fa fa-eye"></i> التفاصيل</button>
                  <button class="btn btn-sm btn-outline-danger" @click="deleteMail(m)" title="حذف"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal id="mail-details" :title="detail ? detail.mail.title : 'التفاصيل'" size="lg" hide-footer>
      <div v-if="!detail" class="text-center g">
        <img :src="require('@/assets/images/loading.svg')" style="width: 50px" alt="">
      </div>
      <template v-else>
        <div class="summary">
          <button v-for="f in filters" :key="f.key" class="chip" :class="{ on: filter == f.key }" @click="filter = f.key">
            {{ f.label }} <span class="num">{{ f.count }}</span>
          </button>
        </div>
        <div class="g"><sort-select id="mail-teachers-sort" v-model="sortMail" no-class></sort-select></div>
        <div class="table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr><th>المعلم</th><th>الحالة</th><th>التوقيع</th><th>الرد</th></tr>
            </thead>
            <tbody>
              <tr v-for="t in shown" :key="t.number">
                <td>{{ t.name }}</td>
                <td class="nowrap">
                  <span v-if="t.signed_at" class="badge bg-success">وقّع</span>
                  <span v-else-if="t.seen_at" class="badge bg-info">قرأ</span>
                  <span v-else class="badge bg-secondary">لم يفتح</span>
                  <small class="d-block text-muted num" v-if="t.seen_at">فتح: {{ t.seen_at }}</small>
                </td>
                <td>
                  <a v-if="t.signature" href="javascript:;" @click="showSign(t)" class="sig">
                    <img :src="t.signature" alt="توقيع">
                  </a>
                  <small v-if="t.signed_at" class="d-block text-muted num">{{ t.signed_at }}</small>
                  <span v-if="!t.signature" class="text-muted">—</span>
                </td>
                <td class="reply">
                  <span v-if="t.reply">{{ t.reply }}</span>
                  <i v-else class="text-muted">لم يتم الرد</i>
                  <small v-if="t.replied_at" class="d-block text-muted num">{{ t.replied_at }}</small>
                </td>
              </tr>
              <tr v-if="!shown.length"><td colspan="4" class="text-center text-muted">لا يوجد معلمون في هذا التصنيف.</td></tr>
            </tbody>
          </table>
        </div>
      </template>
    </b-modal>

    <b-modal id="sign-big" :title="bigSign ? 'توقيع ' + bigSign.name : ''" hide-footer centered>
      <img v-if="bigSign" :src="bigSign.signature" class="big-sign" alt="توقيع">
      <p v-if="bigSign" class="text-center text-muted num mb-0">{{ bigSign.signed_at }}</p>
    </b-modal>
  </div>
</template>

<script>
import { sort_rows } from '@/libs/list-sort'
import { VBModal, BModal } from "bootstrap-vue";
export default {
  components: { BModal },
  directives: { "b-modal": VBModal },
  data() {
    return {
      sortMail: '', // «ترتيب» (SortSelect): sorts the whole list
      user: JSON.parse(localStorage.getItem('user')),
      mails: [],
      loading: true,
      detail: null,
      filter: 'all',
      bigSign: null,
    };
  },
  computed: {
    sortedDetailTeachers() {
      return sort_rows((this.detail && this.detail.teachers) || [], this.sortMail);
    },
    filters() {
      var t = this.detail ? this.detail.teachers : [];
      var n = function(f){ return t.filter(f).length; };
      return [
        { key: 'all', label: 'الكل', count: t.length },
        { key: 'signed', label: 'وقّع', count: n(function(x){ return x.signed_at; }) },
        { key: 'unsigned', label: 'لم يوقّع', count: n(function(x){ return !x.signed_at; }) },
        { key: 'replied', label: 'رد', count: n(function(x){ return x.reply; }) },
        { key: 'unseen', label: 'لم يفتح', count: n(function(x){ return !x.seen_at; }) },
      ];
    },
    shown() {
      if(!this.detail) return [];
      var f = this.filter;
      return this.sortedDetailTeachers.filter(function(x){
        if(f == 'signed') return x.signed_at;
        if(f == 'unsigned') return !x.signed_at;
        if(f == 'replied') return x.reply;
        if(f == 'unseen') return !x.seen_at;
        return true;
      });
    },
  },
  created() {
    if(!checkPer("teachers|mails")){
      this.$router.push('/NotPermitted');
      return false;
    }
    this.getMails();
  },
  methods: {
    pct(n, t) {
      return (t ? Math.round(n * 100 / t) : 0) + '%';
    },
    getMails() {
      var g = this;
      $.post(api + '/user/mails/list', { jwt: g.user.jwt }).then(function(r){
        g.loading = false;
        if(r.status != 100) return alert(r.response, 200);
        g.mails = r.response;
      }).fail(function(){ g.loading = false; });
    },
    open(m) {
      var g = this;
      g.detail = null;
      g.filter = 'all';
      g.$bvModal.show('mail-details');
      $.post(api + '/user/mails/status', { jwt: g.user.jwt, id: m._id }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.detail = r.response;
      });
    },
    showSign(t) {
      this.bigSign = t;
      this.$bvModal.show('sign-big');
    },
    deleteMail(m) {
      var g = this;
      if(!confirm('حذف التعميم «' + m.title + '»؟')) return;
      $.post(api + '/user/teachers/mails/delete', { jwt: g.user.jwt, id: m._id }).then(function(){
        g.getMails();
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.num {
  font-variant-numeric: tabular-nums;
}
.nowrap {
  white-space: nowrap;
}
.mails td {
  vertical-align: middle;
}
.stat {
  min-width: 70px;
}
.stat .bar {
  height: 5px;
  border-radius: 3px;
  background: var(--sk-soft2, #EEF1F6);
  overflow: hidden;
  margin-top: 3px;
}
.stat .bar i {
  display: block;
  height: 100%;
  background: var(--sk-p, #1D4ED8);
}
.stat.ok .bar i {
  background: var(--sk-ok, #079455);
}
.stat.info .bar i {
  background: var(--sk-in, #0086C9);
}
.summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.chip {
  border: 1px solid var(--sk-line, #D5DAE3);
  background: #fff;
  border-radius: 999px;
  padding: 4px 12px;
  font-weight: 700;
  color: var(--sk-text, #344054);
}
.chip.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  color: var(--sk-pi, #1E3A8A);
}
.sig img {
  max-width: 130px;
  max-height: 54px;
  background: #fff;
  border: 1px solid var(--sk-line2, #E6E9EF);
  border-radius: 8px;
  padding: 2px 6px;
}
.reply {
  white-space: pre-line;
  max-width: 280px;
}
.big-sign {
  display: block;
  max-width: 100%;
  margin: 0 auto 8px;
  background: #fff;
}
</style>
